<template>
  <div>
    <SlideShowSection />
    <ProductsSection />
    <AboutSection />
    <ServicesSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import ServicesSection from "../components/sections/ServicesSection.vue";
import AboutSection from "../components/sections/AboutSection.vue";
import ProductsSection from "../components/sections/ProductsSection.vue";

export default {
  components: {
    SlideShowSection,
    ServicesSection,
    AboutSection,
    ProductsSection,
  },
};
</script>
